import { render } from "./dashboard-header.vue?vue&type=template&id=3c2fda68"
import script from "./dashboard-header.vue?vue&type=script&lang=js"
export * from "./dashboard-header.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__